import { Link } from "react-router";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useMfa } from "@/api/check-mfa";

export const MfaCard = () => {
    const { data: totpFactor, isLoading } = useMfa();

    const isSetUp = Boolean(totpFactor);

    return (
        <Card
            size="lg"
            className="flex max-w-[calc(100dvw-2rem)] flex-col gap-y-6"
        >
            <div className="w-full">
                <h2 className="mb-3 text-xl font-semibold">
                    Multi-factor authentication
                </h2>
            </div>
            <div className="flex w-full max-w-full flex-col gap-x-3 gap-y-6 md:w-fit md:min-w-md">
                <div className="flex flex-1 flex-row gap-3 gap-x-4 md:gap-x-8">
                    <p className="w-32 shrink-0 text-sm/6 font-medium text-darkgreen-500">
                        Authenticator app
                    </p>

                    <div className="flex-auto shrink-1 truncate">
                        <p className="truncate">
                            {!isLoading && (isSetUp ? "Set up" : "Not set up")}
                        </p>
                    </div>
                    <div className="flex-1">
                        {!isSetUp && !isLoading && (
                            <Button
                                variant="primary"
                                size="sm"
                                className="ms-auto"
                                asChild
                            >
                                <Link to="mfa">Set up</Link>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </Card>
    );
};
